import { config } from '@iheartjane/config';

/* eslint-disable-next-line no-restricted-imports */
import type { Id } from '@jane/shared/models';

const urlRoot = (storeId: Id) => `${config.apiPath}/stores/${storeId}/specials`;

export const getCurrentStoreSpecials = (storeId: Id, sort?: string) => ({
  url: sort ? `${urlRoot(storeId)}?sort=${sort}` : urlRoot(storeId),
});
